'use client';

import { ConfirmActionModal } from '@web/ui';

type ArchiveJobConfirmModalProps = {
  open: boolean;
  isProcessing?: boolean;
  onConfirm: () => Promise<void> | void;
  onClose: () => void;
};

export function ArchiveJobConfirmModal({
  open,
  isProcessing = false,
  onConfirm,
  onClose,
}: ArchiveJobConfirmModalProps) {
  return (
    <ConfirmActionModal
      open={open}
      title="Archive job?"
      description="This will move the job to archived status."
      confirmButtonLabel="Archive Job"
      confirmButtonVariant="error"
      requireConfirmationText={false}
      isProcessing={isProcessing}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
}
